/* Download hidden card images on actual hover or keyboard focus, not on mobile scroll. */
(function () {
  function enhance(event) {
    if (event.type === 'pointerover' && event.pointerType === 'touch') return;
    if (event.type === 'pointerover' && window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;
    var target = event.target;
    var wrapper = target && target.closest && target.closest('.product-image-wrapper');
    if (!wrapper && target && target.closest) {
      var card = target.closest('.product-grid-item');
      wrapper = card && card.querySelector('.product-image-wrapper');
    }
    if (!wrapper) return;
    var image = wrapper.querySelector('img[data-ex-hover-src]');
    if (!image) return;
    var source = image.getAttribute('data-ex-hover-src');
    image.removeAttribute('data-ex-hover-src');
    image.addEventListener('load', function () { wrapper.classList.add('ex-hover-ready'); }, { once: true });
    image.loading = 'eager';
    var srcset = image.getAttribute('data-ex-hover-srcset');
    if (srcset) image.srcset = srcset;
    image.src = source;
  }
  document.addEventListener('pointerover', enhance, { passive: true });
  document.addEventListener('focusin', enhance);
})();

